module.exports = __webpack_public_path__ + "img/light-mud-decal-08.8a1e3ad5.png";